<div class="bcg p-4">
<div class="d-flex justify-content-between custom-container">
    <nav class="custom-nav">
        <ol class="breadcrumb">

            <li
                *ngIf="userRole === 'CLIENT'; else showAdminDashboard"
                class="breadcrumb-item"
                style="cursor: pointer;"
                [routerLink]="'/doqfy/dashboard'"
            >
                Dashboard
            </li>

            <ng-template #showAdminDashboard>
                <li
                    class="breadcrumb-item"
                    style="cursor: pointer;"
                    [routerLink]="'/doqfy/admin-dashboard'"
                >
                    Dashboard
                </li>
            </ng-template>

            <li class="breadcrumb-item" style="cursor: pointer;" [routerLink]="'/doqfy/bulk-upload/form/cat-import'">
                Contract Import
            </li>
            <li class="breadcrumb-item active" aria-current="page">
                Document's List
            </li>
        </ol>
    </nav>
</div>

  <div class="card card_outLine mt-3">
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="title_five">
            Document's List
          </h5>

          <p class="card-text text_p">
            View and manage all documents imported through Contract Import.
          </p>
        </div>

        <div
          class="col-lg-6 col-sm-6 col-md-6 text-right custom_button"
        >
          <p-button
            label="Back"
            (click)="goBack()"
            styleClass="p-button-sm"
          ></p-button>
        </div>
      </div>
    </div>
  </div>

  <div class="card card_outLine mt-3">
    <div class="card-body">

      <div class="row mx-1 align-items-center">

        <div class="col-lg-5 col-sm-5 col-md-5">

          <h5 class="title_five">
            Document Details
          </h5>

        </div>

        <div
          class="d-flex col-lg-7 col-sm-7 col-md-7 justify-content-end account-filters"
        >
          <div class="form_inputFields_mangment document-search">

            <app-search-input
              [(ngModel)]="searchText"
              (ngModelChange)="onSearchChange($event)"
              placeholder="Search by Document Name, Order ID or Ref. ID"
            ></app-search-input>

          </div>

          <div class="form_inputFields_mangment ms-2 document-date-filter">
            <p-datepicker
              class="custom-datepicker"
              styleClass="w-80"
              [(ngModel)]="rangeDates"
              (onSelect)="onDateSelect()"
              (ngModelChange)="onDateRangeChange($event)"
              placeholder="Select date range"
              [showIcon]="true"
              iconDisplay="input"
              [maxDate]="maxDate"
              selectionMode="range"
              [readonlyInput]="true"
              dateFormat="dd M yy"
              [showButtonBar]="true"
            ></p-datepicker>
          </div>
          <app-column-chooser class="ms-2" [table]="dataTable"></app-column-chooser>
        </div>
      </div>
        


<div class="card table-card">
  <div class="card-body p-0">

    <app-data-table
      #dataTable
      [columns]="tableColumns"
      [data]="displayedDocuments"
      [loading]="loading"
      [paginator]="true"
      [rows]="pageSize"
      [totalRecords]="totalRecords"
      [emptyMessage]="'No imported contracts match your selected criteria.'"
      [scrollable]="false"
      (pageChange)="onPaginationChange($event)"
      (rowsChange)="onRowsPerPageChange($event)"
      [columnChooser]="true"
      (columnVisibilityChange)="onColumnVisibilityChange($event)"
      (rowClick)="viewDocument($event)"
    >

      <ng-template appTableCell="document_name" let-row>
        <div class="d-flex align-items-center">

          <span class="doc-icon-badge me-2">
            <i class="pi pi-file-pdf"></i>
          </span>

          <span
            class="doc-title-text fw-medium"
            [pTooltip]="row.document_name"
            tooltipPosition="top"
          >
            {{ row.document_name }}
          </span>

        </div>
      </ng-template>

      <ng-template appTableCell="status" let-row>
        <span
        class="status-badge"
        [ngClass]="getStatusClass(row.status)"
        >
         {{ row.status }}
         </span>
      </ng-template>

      <ng-template appTableCell="actions" let-row>
        <div class="document-actions d-flex align-items-center gap-2" appRowActionStop>        

          <button
            type="button"
            class="btn btn-action btn-action--view"
            (click)="viewDocument(row)"
            pTooltip="View Document"
            tooltipPosition="top"
          >
            <i class="pi pi-eye me-1"></i>
          </button>

          <button
            type="button"
            class="btn btn-action btn-action--download"
            (click)="downloadDocument(row)"
            pTooltip="Download Document"
            tooltipPosition="top"
          >
            <i class="pi pi-download me-1"></i>
          </button>

        </div>
      </ng-template>

    </app-data-table>

  </div>
</div>

<!-- ========================================================================= -->
<!--  VIEW DOCUMENT MODAL                                                     -->
<!-- ========================================================================= -->
<ng-template #viewDocModal let-modal>
  <div class="modal-header border-0 pb-2 pt-3 px-4 d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <i class="pi pi-file-pdf text-purple fs-5 me-2"></i>
      <h5 class="modal-title fw-semibold text-truncate mb-0" style="max-width: 700px;">
        {{ selectedDoc?.document_name }}
      </h5>
    </div>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body p-3 doc-preview-modal-body">
    <div *ngIf="pdfLoading" class="text-center py-5">
      <i class="pi pi-spin pi-spinner text-purple fs-2 mb-3 d-block"></i>
      <span class="text-muted">Loading document preview...</span>
    </div>

    <div *ngIf="!pdfLoading && pdfError" class="text-center py-5">
      <i class="pi pi-exclamation-triangle text-warning fs-2 mb-3 d-block"></i>
      <h6 class="text-secondary">Document preview could not be loaded.</h6>
      <p class="text-muted small">You can still download the document directly.</p>
      <button
        type="button"
        class="btn btn-primary btn-sm mt-2"
        (click)="downloadDocument(selectedDoc!); modal.close()"
      >
        <i class="pi pi-download me-1"></i> Download PDF
      </button>
    </div>

    <div *ngIf="!pdfLoading && !pdfError && pdfSource" class="iframe-container">
      <iframe
        [src]="pdfSource"
        class="doc-preview-iframe"
        allowfullscreen
        title="Document Preview"
      ></iframe>
    </div>
  </div>
</ng-template>

<!-- ========================================================================= -->
<!--  DOWNLOAD STARTED MODAL                                                 -->
<!-- ========================================================================= -->
<ng-template #downloadSuccessModal let-modal>
  <div class="modal-body text-center p-4">
    <div class="download-icon-circle mx-auto mb-3">
      <svg
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="11" fill="#12B76A" stroke="#12B76A" stroke-width="2" />
        <path
          d="M7 12.5L10.5 16L17 8.5"
          stroke="white"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <h5 class="fw-bold mb-2 download-modal-title">Download Started</h5>
    <p class="text-muted small mb-4">
      The document "<span class="fw-medium text-dark">{{ downloadModalDocName }}</span>" is being downloaded.
    </p>

    <button
      type="button"
      class="btn btn-close-modal px-4 py-2"
      (click)="modal.close()"
    >
      Close
    </button>
  </div>
</ng-template>
</div>
